// export enum TransferWorkshopStoreEnums {
//   //Tipo
//   almacen = 1,
//   taller2 = 2,
//   taller3 = 3,
//   //Estados
//   estadoAbierto = 1,
//   estadoCerrado = 2,
//   estadoaAnulado = 3
// }

export enum TransferWorkshopStoreStateEnums {
  open = 1,
  close = 2,
  annulled = 3,
  printed = 4,
}

export enum TransferWorkshopStoreTypeEnums {
  cleaning = 2,
  repair = 3,
}